import { __require as s } from "./constant.js";
import { __require as _ } from "./_defineProperty.js";
import { __require as f } from "./identity.js";
var r, t;
function m() {
  if (t) return r;
  t = 1;
  var i = s(), e = _(), n = f(), a = e ? function(o, u) {
    return e(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: i(u),
      writable: !0
    });
  } : n;
  return r = a, r;
}
export {
  m as __require
};
